<template>
  <nav
    class="navbar is-primary no-print"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/">
        <!-- <img src="@/assets/logo.png" width="30" height="30"> -->
        <span>&nbsp;&nbsp;{{ this.user.username }}</span>
      </router-link>
      <a
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
        :class="{ 'is-active': isMenuActive }"
        @click="isMenuActive = !isMenuActive"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
      <div class="navbar-start">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ອອກຕະຫຼາດ-ວຽກຫ້ອງການ</span>
          </a>

          <div class="navbar-dropdown">

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/b2bcontractpurchasemanagebill"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການບິນ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/b2bcontractpurchaseprice"
              :exact="true"
              active-class="is-active"
            >
              <span>ປັບລາຄາ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/b2bcontractpurchasejoinbill"
              :exact="true"
              active-class="is-active"
            >
              <span>ລວມບິນ-ມອບອໍເດີ້</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/b2bcontractpurchasecustomer"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕິດຕາມສັນຍາຈັດຊື້</span>
            </router-link>

          </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ສາງສິນຄ້າ</span>
          </a>

          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/stock/checkstock"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕິດຕາມສິນຄ້າໃນສາງ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/stock/stockproductpurchasev2"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດຊື້ສິນຄ້າເຂົ້າສາງ V2</span>
            </router-link>
            <router-link
              @click.native="menuClicked"   
              class="navbar-item"
              to="/stock/stockoutwait"
              :exact="true"
              active-class="is-active"
            >
              <span>ສິນຄ້າອອກສາງ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/stock/stockmanagement"
              :exact="true"
              active-class="is-active"
            >
              <span>ສິນຄ້າເຂົ້າ-ອອກສາງ</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/stock/stockproductdailyprice"
              :exact="true"
              active-class="is-active"
            >
              <span>ອັບເດດລາຄາສິນຄ້າ ປະຈຳວັນ</span>
            </router-link>

          </div>
        </div>
        
      </div>

      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຕັ້ງຄ່າຕ່າງໆ</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              v-if="roleid == '6'"
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/setting/user"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການຜູ້ໃຊ້ DASM ສາຂາ</span>
            </router-link>

            <router-link
              v-if="roleid == '6'"
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/setting/branch"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການສາຂາ</span>
            </router-link>

            <router-link
              v-if="roleid == '6' || roleid == '7'"
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/setting/b2buser"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການ B2B User</span>
            </router-link>

            <router-link
              v-if="roleid == '6' || roleid == '7'"
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/setting/market"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການຕະຫຼາດ</span>
            </router-link>

            <router-link
              v-if="roleid == '6' || roleid == '7'"
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/setting/shippingfee"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການຄ່າສົ່ງ</span>
            </router-link>
            <router-link
              v-if="roleid == '6' || roleid == '7'"
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/setting/purchaser"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕັ້ງຄ່າອອກຕະຫຼາດ</span>
            </router-link>

            <router-link
              v-if="roleid == '6' || roleid == '7'"
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/setting/productbuyvender"
              :exact="true"
              active-class="is-active"
            >
              <span>ຕັ້ງຄ່າສິນຄ້າ-Vender</span>
            </router-link>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຜູ້ໃຊ້ງານ {{ rolename }}</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/profile"
              :exact="true"
              active-class="is-active"
            >
              <span>ຂໍ້ມູນສ່ວນຕົວ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/login"
              :exact="true"
              active-class="is-active"
            >
              <span>ອອກຈາກລະບົບ</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "ReportMenu",
  data() {
    return {
      isMenuActive: false,
      roleid: null,
      rolename: null,
    };
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.rolename = this.user.ROLENAME;
    // console.log("roleid: "+ JSON.stringify(this.roleid))
  },
  computed: {
    // user: get("loginData"),
  },
  methods: {
    menuClicked() {
      this.isMenuActive = false;
    },
  },
};
</script>

<style scoped>
.navbar-item {
  white-space: nowrap;
}
.navbar-end {
  padding-right: 60px;
}
</style>
